export default __webpack_public_path__ + "static/media/dad.1dbb01c7.ogg";